var s,b;!function(s){s.MissingConsentPayload="MISSING_MARKERTING_CONSENT_PAYLOAD"}(s||(s={})),function(s){s.Subscribed="subscribed",s.NotSubscribed="not_subscribed",s.Unsubscribed="unsubscribed"}(b||(b={}));export{s as UnlikelyCustomerErrors,b as UnlikelyMarketingState};
//# sourceMappingURL=customers.js.map
